










































































































import Vue from "vue";
import Component from "vue-class-component";
import {Prop, Watch} from "vue-property-decorator";
import {Getter} from "vuex-class";
import _ from "lodash";
import Http from "front-component/Http";
import ChartRenderer from "../charts/ChartRenderer.vue";
import MarkdownRenderer from "../MarkdownRenderer.vue";
import AiInteractionRepository from "@/repositories/AiInteractionRepository";
import store from "@/store";
import * as Constants from "@/Constants";

interface ChartConfig {
    chart_type: string;
    x_axis: string;
    y_axis: string | string[];
    title: string;
}

interface AiQueryResponse {
    response_text: string;
    query_results: any[];
    chart_config: ChartConfig;
}

@Component({
    components: {
        ChartRenderer,
        MarkdownRenderer
    }
})
export default class ChatBotDrawer extends Vue {
    @Prop({default: false}) public visible!: boolean;
    @Getter("getCurrentOwnerUuid") public currentOwnerUuid!: string;

    private promptsCollapsed: boolean = false;
    private chatInput: string = "";
    private isThinking: boolean = false;
    private hasAskedQuestion: boolean = false;
    private currentQuestion: string = "";
    private currentAnswer: string = "";
    private chartData: any[] | null = null;
    private chartConfig: any | null = null;
    private predefinedPrompts: string[] = [
        "analysisOperationDecember",
        "analysisCpmCompare",
        "analysisEvolutionCpc",
        "analysisBudgetTotal",
        "analysisBestRateCampaignClick"
    ];
    private userQuestions: string[] = [];
    private userQuestionsLoaded: boolean = false;
    private AiInteractionTypes: { [key: string]: string } = Constants.AiInteractionTypes;
    private showToggleButton: boolean = true;
    private showPromptContent: boolean = true;

    private get drawerVisible(): boolean {
        return this.visible;
    }

    private set drawerVisible(value: boolean) {
        this.$emit("update:visible", value);
    }

    private get displayedPrompts(): string[] {
        if (!this.userQuestionsLoaded) {
            return [];
        }
        return this.userQuestions.length > 0 ? this.userQuestions : this.predefinedPrompts;
    }

    private get hasUserQuestions(): boolean {
        return this.userQuestions.length > 0;
    }

    private get promptsLabel(): string {
        return this.hasUserQuestions ? "myQuestions" : "sentenceAI";
    }

    public created(): void {
        this.loadUserQuestions();
    }

    @Watch("currentOwnerUuid")
    private onOwnerChanged(): void {
        this.loadUserQuestions();
    }

    private loadUserQuestions(): void {
        if (!this.currentOwnerUuid) {
            return;
        }

        this.userQuestionsLoaded = false;
        AiInteractionRepository.get({
            fields: ["question"],
            filters: {
                type: Constants.AiInteractionTypes.campaignQuery,
                ownerUuid: this.currentOwnerUuid,
                createdByUuid: _.get(store, "getters.getCurrentUser.uuid", "")
            },
            pagination: {
                nb_per_page: Constants.MAX_AI_LAST_QUESTIONS,
                page: 1,
            }
        }).then((data: object[]) => {
            this.userQuestions = data
                .map((item: any) => item.question)
                .filter((q: string) => !!q);
            this.userQuestionsLoaded = true;
        }).catch(() => {
            this.userQuestionsLoaded = true;
        });
    }

    private selectPrompt(prompt: string): void {
        this.chatInput = _.invoke(this.$options.filters, "trans", prompt);
    }

    private sendMessage(): void {
        const message = this.chatInput.trim();
        if (!message || this.isThinking) {
            return;
        }

        this.currentQuestion = message;
        this.hasAskedQuestion = true;
        this.chatInput = "";
        this.isThinking = true;
        this.currentAnswer = "";

        this.userQuestions.unshift(message);
        if (this.userQuestions.length > Constants.MAX_AI_LAST_QUESTIONS) {
            this.userQuestions.pop();
        }

        Http.search(
            "/ai/campaign/query",
            {clientUuid: this.currentOwnerUuid, question: message},
            (data: AiQueryResponse) => {
                this.isThinking = false;
                this.currentAnswer = data.response_text;
                this.chartData = data.query_results;
                this.chartConfig = data.chart_config;
            },
            () => {
                this.isThinking = false;
                this.currentAnswer = _.invoke(this.$options.filters, "trans", "chatBotError");
            }
        );
    }

    private resetChat(): void {
        this.hasAskedQuestion = false;
        this.currentQuestion = "";
        this.currentAnswer = "";
        this.chartData = null;
        this.chartConfig = null;
        this.chatInput = "";
        this.isThinking = false;
    }

    private togglePrompts(): void {
        this.showToggleButton = false;
        if (!this.promptsCollapsed) {
            this.showPromptContent = false;
            this.promptsCollapsed = true;
        } else {
            this.promptsCollapsed = false;
        }
        setTimeout(() => {
            this.showPromptContent = !this.promptsCollapsed;
            this.showToggleButton = true;
        }, 350);
    }
}
